export default __webpack_public_path__ + "static/media/demand.02a47407.svg";